import { normalizeStatusLabel } from "../../../../../../../../../shared/utils/normalize-status-label";
import type { AppInfo } from "../../../../../../../../../shared/types/dashboard-data.type";

const APP_STATUS_ALLOWED = new Set([
	"ENABLED",
	"PENDING",
	"MODERATION",
	"REMOVED",
	"UPDATE",
	"BANNED",
	"EXTERNAL",
]);

const APP_STATUS_MAP: Record<string, string> = {
	ENABLED: "ENABLED",
	PENDING: "PENDING",
	MODERATION: "MODERATION",
	REMOVED: "REMOVED",
	UPDATE: "UPDATE",
	BANNED: "BANNED",
	PAUSED: "MODERATION",
	DISABLED: "REMOVED",
	ACCEPTED: "ENABLED",
	EXTERNAL: "EXTERNAL",
	"?": "EXTERNAL",
};

export const mapAppStatus = (
	raw: string | number | null | undefined,
): string | null => {
	const normalized = normalizeStatusLabel(raw);
	if (!normalized) return null;
	const mapped = APP_STATUS_MAP[normalized] ?? normalized;
	return APP_STATUS_ALLOWED.has(mapped) ? mapped : null;
};

export const appStatusForFilterSelect = (raw: string): string =>
	mapAppStatus(raw) ?? String(raw).trim();

export const prepareAppsForDisplay = (
	apps: AppInfo[] | undefined,
): AppInfo[] =>
	(apps ?? []).flatMap((app) => {
		const displayStatus = mapAppStatus(app.status);
		if (!displayStatus) return [];
		return [{ ...app, status: displayStatus }];
	});
